import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FormControl, FormHelperText, FormLabel, Stack, Switch, Typography } from "@mui/material";
import { useId } from "react";
import { Controller, get, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { IconTooltip } from "./IconTooltip";
export const SwitchInput = (props)=>{
    const labelId = useId();
    const offId = useId();
    const onId = useId();
    const errorId = useId();
    const formContext = useFormContext();
    const translation = useTranslation();
    const error = get(formContext.formState.errors, props.name);
    const onChange = (field, checked)=>{
        field.onChange(checked);
        if (props.onChange) {
            props.onChange(checked);
        }
    };
    return /*#__PURE__*/ _jsx(Controller, {
        control: formContext.control,
        name: props.name,
        render: ({ field })=>/*#__PURE__*/ _jsxs(FormControl, {
                error: !!error,
                fullWidth: props.fullWidth,
                required: props.required,
                children: [
                    props.label && /*#__PURE__*/ _jsx(FormLabel, {
                        "data-component": "text",
                        "data-testid": `${props['data-testid'] ?? props.name}Label`,
                        disabled: props.disabled,
                        id: labelId,
                        required: props.required,
                        children: props.label
                    }),
                    /*#__PURE__*/ _jsxs(Stack, {
                        alignItems: "center",
                        direction: "row",
                        spacing: 1,
                        children: [
                            props.off && /*#__PURE__*/ _jsx(Typography, {
                                "data-testid": `${props['data-testid'] ?? props.name}Off`,
                                id: offId,
                                children: props.off
                            }),
                            /*#__PURE__*/ _jsx(Switch, {
                                "aria-describedby": errorId,
                                "aria-disabled": props.disabled,
                                "aria-labelledby": `${labelId} ${props.on ? onId : ''} ${props.off ? offId : ''}`,
                                checked: field.value || false,
                                color: props.color,
                                disabled: props.disabled,
                                onChange: (e)=>onChange(field, e.target.checked),
                                readOnly: props.readOnly,
                                required: props.required,
                                slotProps: {
                                    input: {
                                        'aria-checked': field.value,
                                        //@ts-expect-error: lib bug
                                        'data-component': 'switch',
                                        'data-testid': props['data-testid'] ?? props.name
                                    }
                                }
                            }),
                            props.on && /*#__PURE__*/ _jsx(Typography, {
                                "data-testid": `${props['data-testid'] ?? props.name}On`,
                                id: onId,
                                children: props.on
                            }),
                            props.tooltipIcon && /*#__PURE__*/ _jsx(IconTooltip, {
                                size: "medium",
                                trigger: props.tooltipIcon,
                                children: props.tooltip
                            })
                        ]
                    }),
                    !props.hideError && /*#__PURE__*/ _jsx(FormHelperText, {
                        id: errorId,
                        children: translation.t(error?.message) || ' '
                    })
                ]
            })
    });
};
SwitchInput.displayName = 'SwitchInput';

//# sourceMappingURL=SwitchInput.js.map